module.exports = __webpack_public_path__ + "img/baoming.394ff89.png";